import React, { FC } from 'react';
import { CategoryPageBucketEntry } from '../../../../models/CategoryPage';
import { SidebarList, SidebarListContainer, SidebarListItemTargetBuilderFunc } from '../SidebarList';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly recommendedPublishers: ReadonlyArray<CategoryPageBucketEntry>;
    readonly topPublishers: ReadonlyArray<CategoryPageBucketEntry>;
    readonly selectedGenre: string;
    readonly loanFormatUrlKey: string; // urlKey
    readonly itemTargetBuilder: SidebarListItemTargetBuilderFunc;
};

export const PublisherPageSidebar: FC<Props> = ({
    recommendedPublishers,
    loanFormatUrlKey,
    selectedGenre,
    itemTargetBuilder,
    topPublishers
}) => {
    const { t } = useTranslation();
    return (
        <SidebarListContainer>
            <SidebarList
                title={t('shop.publishers.recommendedPublishers')}
                entries={recommendedPublishers}
                selectedEntry={selectedGenre}
                loanFormatUrlKey={loanFormatUrlKey}
                itemTargetBuilder={itemTargetBuilder}
            />
            <SidebarList
                title={t('shop.publishers.topPublishers')}
                entries={topPublishers}
                selectedEntry={selectedGenre}
                loanFormatUrlKey={loanFormatUrlKey}
                itemTargetBuilder={itemTargetBuilder}
            />
        </SidebarListContainer>
    );
};
